export default __webpack_public_path__ + "static/medical_gas_w.d3b3e6bb1ef67c02d86995f163a1a8d2.png";